// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"vo-z","badgeLink":"wo-z","category":"xo-z"};